import React from "react";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { BackArrow } from "icons";

const DialogAction = ({
  classes,
  currentSlide,
  handlePrevClick,
  handleNextClick,
  handleClick,
  slides,
}) => {
  const renderDots = (item, index) => {
    return (
      <div
        className={`${classes.circle} ${currentSlide === index && classes.active}`}
        onClick={handleClick.bind(this, index)}
      />
    );
  };
  return (
    <MuiDialogActions
      classes={{
        root: classes.dialogAction,
      }}
    >
      <div
        className={`${classes.arrow} ${currentSlide === 0 && classes.visibility}`}
        onClick={handlePrevClick}
      >
        <BackArrow />
      </div>
      {slides.map(renderDots)}
      <div
        className={`${classes.arrow} ${classes.forwardArrow} ${currentSlide === slides.length - 1 && classes.visibility
          }`}
        onClick={handleNextClick}
      >
        <BackArrow />
      </div>
    </MuiDialogActions>
  );
};

export default DialogAction;